<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.interventions', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <div class="mt-5 md:grid md:grid-cols-5 lg:grid-cols-3 md:gap-6">
                <div class="mt-5 md:mt-0 md:col-span-4 lg:col-span-2">
                    <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-8">
                        <div class="sm:col-span-2">
                            <div class="mt-1">
                                <FormLabel
                                    :value="$t('messages.evaluation_request_date')"
                                    for="evaluation_request_date"
                                />
                                <FormInput
                                    id="evaluation_request_date"
                                    v-model="form.evaluation_request_date"
                                    name="evaluation_request_date"
                                    type="date"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.evaluation_request_date" class="mt-2" />
                            </div>
                        </div>

                        <div class="sm:col-span-2">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.evaluation_date')" for="evaluation_date" />
                                <FormInput
                                    id="evaluation_date"
                                    v-model="form.evaluation_date"
                                    name="evaluation_date"
                                    type="date"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.evaluation_date" class="mt-2" />
                            </div>
                        </div>

                        <div class="sm:col-span-2">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.monitoring')" for="monitoring" />
                                <FormSelect
                                    id="monitoring"
                                    v-model="form.monitoring"
                                    name="monitoring"
                                    :options="options.yesNo"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.monitoring" class="mt-2" />
                            </div>
                        </div>

                        <div class="sm:col-span-2">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.type')" for="type" />
                                {{ intervention.type }}
                                <FormError :value="form.errors.type" class="mt-2" />
                            </div>
                        </div>

                        <div class="sm:col-span-2">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.assessment')" for="assessment" />
                                <FormSelect
                                    id="assessment"
                                    v-model="form.assessment"
                                    name="assessment"
                                    :options="options.yesNo"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.assessment" class="mt-2" />
                            </div>
                        </div>
                        <div class="sm:col-span-6">
                            <div class="mt-1">
                                <FormLabel
                                    :value="`${$t('messages.comment')}: ${$t('messages.assessment')}`"
                                    for="assessment_comment"
                                />
                                <FormTextarea
                                    rows="3"
                                    id="assessment_comment"
                                    v-model="form.assessment_comment"
                                    name="assessment_comment"
                                    class="mt-1"
                                />
                                <FormError :value="form.errors.assessment_comment" class="mt-2" />
                            </div>
                        </div>

                        <div class="sm:col-span-2">&nbsp;</div>
                        <div class="sm:col-span-6">
                            <div class="mt-1">
                                <FormLabel
                                    :value="`${$t('messages.comment')}: ${$t('messages.report')}`"
                                    for="report_comment"
                                />
                                <FormTextarea
                                    rows="3"
                                    id="report_comment"
                                    v-model="form.report_comment"
                                    name="report_comment"
                                    type="text"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.report_comment" class="mt-2" />
                            </div>
                        </div>

                        <div class="sm:col-span-2">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.interventions')" for="intervention" />
                                <FormSelect
                                    id="intervention"
                                    v-model="form.intervention"
                                    name="intervention"
                                    :options="options.yesNo"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.intervention" class="mt-2" />
                            </div>
                        </div>
                        <div class="sm:col-span-6">
                            <div class="mt-1">
                                <FormLabel
                                    :value="`${$t('messages.comment')}: ${$t('messages.interventions')}`"
                                    for="intervention_comment"
                                />
                                <FormTextarea
                                    rows="3"
                                    id="intervention_comment"
                                    v-model="form.intervention_comment"
                                    name="intervention_comment"
                                    type="text"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.intervention_comment" class="mt-2" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-end mt-5">
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        PanelPage,
        FormInput,
        FormLabel,
        FormError,
        FormSelect,
        FormTextarea,
        AppButton,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'intervention'],
    data() {
        return {
            form: this.$inertia.form({
                assessment: this.intervention.assessment,
                intervention: this.intervention.intervention,
                monitoring: this.intervention.monitoring,
                evaluation_request_date: this.intervention.evaluation_request_date,
                evaluation_date: this.intervention.evaluation_date,
                intervention_comment: this.intervention.intervention_comment,
                assessment_comment: this.intervention.assessment_comment,
                report_comment: this.intervention.report_comment,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
